<template>
  <div class="animated fadeIn revisikirimanfrm">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <button
            v-if="saveEnabled"
            class="btn btn-primary mr-1"
            @click.stop="save"
          >
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </b-button>
        </div>
      </div>
        <b-row>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend>
                <label>Faktur Pengiriman</label>
              </b-input-group-prepend>
              <b-form-input
                readonly
                v-model="model.nofaktur"
                @keyup.13.native="lkuKoranKirimanShow=true"
                :state="!$v.model.kirimanKey.$error"
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" id="btnKoranCust" @click="lkuKoranKirimanShow=true" :disabled="isEdit">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
              <b-input-group-prepend>
                <label class="text-right mr-2">Tanggal Kirim</label>
              </b-input-group-prepend>
              <b-form-input v-model="model.tanggal" readonly></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Nama Agen</label>
              </b-input-group-prepend>
              <b-form-input v-model="model.CustInfo" readonly></b-form-input>
            </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Alamat Pengiriman</label>
            </b-input-group-prepend>
              <b-form-textarea v-model="model.address" disabled rows="2" max-rows="5"></b-form-textarea>
          </b-input-group>
          <b-row>
             <b-col lg="6">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Telepon</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.PhoneNo" readonly></b-form-input>
                </b-input-group>
             </b-col>  
          </b-row>
            <b-input-group>
              <b-input-group-prepend>
                <label>Jurusan</label>
              </b-input-group-prepend>
              <input
                v-model="model.jurusan_info"
                type="text"
                placeholder="Kode | nama jurusan"
                class="form-control"
                readonly
              />
              <b-input-group-prepend>
                <span class="pl-2 pt-2">Titik Drop</span>
              </b-input-group-prepend>
              <b-form-input v-model="model.titikdrop" placeholder="Drop point" readonly></b-form-input>
            </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Nama Ekspedisi</label></b-input-group-prepend>
            <b-form-input v-model="model.ekspedisi_name" readonly></b-form-input>
            <b-input-group-prepend><span class="p-2">Telepon</span></b-input-group-prepend>
            <b-form-input v-model="model.ekspedisi_tlp" readonly></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Sales Executive</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.salesae_name"
              placeholder="Sales Executive"
            ></b-form-input>
            <b-input-group-prepend>
              <label class="text-right">Kolektor</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.collector_name"
              placeholder="Kolektor"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Jenis Kiriman</label>
            </b-input-group-prepend>
              <input
                v-model="model.kiriman_name"
                type="text"
                placeholder="Jenis kiriman"
                class="form-control"
                readonly
              />
              <b-input-group-prepend>
                <span class="pl-2 pt-2">Kota/Area</span>
              </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.kota_name"
              placeholder="Kota/Area"
            ></b-form-input>
          </b-input-group>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>Harga Koran </label></b-input-group-prepend>
                <v-number class="form-control text-right " separator="," v-model="model.hrg_agen_ecer" readonly></v-number>            
              </b-input-group>
            </b-col>
          </b-row>

          </b-col>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend>
                <label style="width:160px !important;">Tanggal Revisi</label>
              </b-input-group-prepend>
              <b-form-input
                type="date"
                v-model="model.tglrevisi"
                :state="!$v.model.tglrevisi.$error"
              ></b-form-input>
              <b-input-group-prepend>
                <label class="text-right">No. Revisi </label>
              </b-input-group-prepend>
              <b-form-input  v-model="model.no_revisi" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING"></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label style="width:160px !important;">Kelompok Adjustment</label>
              </b-input-group-prepend>
              <b-form-select
                v-model="model.revisigrpKey"
                placeholder=" -- Pilih Group -- "
                :options="revisigrp"
                :state="!$v.model.revisigrpKey.$error"
              >
                <template v-slot:first>
                  <option :value="null" disabled>-- Pilih Group --</option>
                </template>
              </b-form-select>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend><label style="width:160px !important;">Uraian Revisi/Adjustment</label></b-input-group-prepend>
              <b-form-input
                separator=","
                :state="!$v.model.uraian.$error"
                v-model="model.uraian"
              ></b-form-input>
            </b-input-group>

      <div class="report-wraper mt-2">
        <table style="width: 100%;">
            <!-- <table class="table table-sm table-bordered"> -->
              <thead>
                <tr>
                  <th scope="col" class="text-center" rowspan="2">Jenis</th>
                  <th scope="col" class="text-center" colspan="3" >Kiriman sebelum Revisi</th>
                  <th scope="col" class="text-center" colspan="2">Revisi Kali ini</th>
                </tr>
                <tr>
                  <th scope="col" class="text-center">Awal Kirim</th>
                  <th scope="col" class="text-center">Telah diRevisi</th>
                  <th scope="col" class="text-center">Total Akhir</th>

                  <th scope="col" class="text-center">Isi dg Total Akhir!</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th >Berbayar NON RETUR</th>
                  <td class="text-right">{{model.langganan|numFormat}}  eks.</td>
                  <td class="text-right">{{model.revlangg|numFormat}} eks.</td>
                  <td class="text-right">{{(model.langganan+model.revlangg)|numFormat}} eks.</td>
                  <td>
                      <b-form-input
                        type="number" class="form-control text-right"
                        v-model="model.langg_akhir"
                        :min="0" 
                      ></b-form-input>
                  
                    <!-- <v-number
                      class="form-control text-right"
                      separator=","  
                      v-model="model.langg_akhir"
                    ></v-number> -->
                  </td>
                </tr>
                <tr>
                  <th >BerBayar BISA RETUR</th>
                  <td class="text-right">{{model.konsi|numFormat}}  eks.</td>
                  <td class="text-right">{{model.revkonsi|numFormat}}  eks.</td>
                  <td class="text-right">{{(model.konsi+model.revkonsi)|numFormat}} eks.</td>
                  <td>
                      <b-form-input
                        type="number" class="form-control text-right"
                        v-model="model.konsi_akhir"
                        :min="0" 
                      ></b-form-input>
                    <!-- <v-number
                      class="form-control text-right"
                      separator=","  
                      v-model="model.konsi_akhir"
                    ></v-number> -->
                  </td>
                </tr>
                <tr>
                  <th >Tdk.Bayar</th>
                  <td class="text-right">{{model.gratis|numFormat}} eks.</td>
                  <td class="text-right">{{model.revgratis|numFormat}} eks.</td>
                  <td class="text-right">{{(model.gratis+model.revgratis)|numFormat}} eks.</td>
                  <td>
                      <b-form-input
                        type="number" class="form-control text-right"
                        v-model="model.gratis_akhir"
                        :min="0" 
                      ></b-form-input>

                    <!-- <v-number
                      class="form-control text-right"
                      separator=","
                      v-model="model.gratis_akhir"
                    ></v-number> -->
                  </td>
                </tr>                
                <!-- <tr>
                  <th >Titipan</th>
                  <td class="text-right">{{model.titipan|numFormat}} eks.</td>
                  <td class="text-right">{{model.revtitipan|numFormat}} eks.</td>
                  <td class="text-right">{{(model.titipan+model.revtitipan)|numFormat}} eks.</td>
                  <td>
                    <v-number
                      class="form-control text-right"
                      separator=","
                      v-model="model.titipan_akhir"
                    ></v-number>
                  </td>
                </tr> -->
                <tr>
                  <th class="text-right">TOTAL</th>
                  <td class="text-right" style="background-color:#e4e7ea;">{{model.totkirim|numFormat}} eks.</td>
                  <td class="text-right" style="background-color:#e4e7ea;">{{model.revtotal|numFormat}} eks.</td>
                  <!-- <td class="text-right" style="background-color:#e4e7ea;">{{(model.totkirim-model.revtotal)|numFormat}} eks.</td> -->
                  <td class="text-right" style="background-color:#e4e7ea;">{{( (model.langganan+model.revlangg) + (model.konsi+model.revkonsi) + (model.gratis+model.revgratis))|numFormat}} eks.</td>
                  <th class="text-right" style="background-color:#e4e7ea;">{{(parseInt(model.langg_akhir)+parseInt(model.konsi_akhir)+parseInt(model.gratis_akhir))|numFormat(0)}} &nbsp;&nbsp;&nbsp;</th>
                </tr>                
              </tbody>
            </table>
        </div>
          </b-col>
        </b-row>
        <br />
      <b-row class="justify-content-center mb-2">
        <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save">
          <i class="fa fa-save"></i> Save
        </button>
        <b-button class="btn btn-primary mr-1" @click.stop="close()">
          <i class="fa fa-close"></i> Close
        </b-button>
      </b-row>
    </b-card>


    <b-modal v-model="lkuKoranKirimanShow" size="lg" :hide-footer="true" title="List Pengiriman" :centered="true">
      <lku-koran-kiriman @click="onSelectKoranKiriman" :tgl1="tglkiriman"></lku-koran-kiriman>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>
<style lang="scss">
  .revisikirimanfrm {
    .input-group {
      padding-bottom: 2px;
      .input-group-prepend {
        label {
          padding-top: 5px;
          padding-right: 5px;
          width: 130px;
        }
      }
    }
  }
</style>
<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';
import vNumber from "../../components/my-number";
import crud from "../../apis/crud";
import koran_kiriman_revisi from "../../apis/koran_kiriman_revisi";
import lkuKoranKiriman from "../lookup/lkuKoranKiriman";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { vNumber, lkuKoranKiriman, Loading },
  mixins: [validationMixin],
  validations: {
    model: {
      kirimanKey: { required },
      // langg_akhir: {
      //   required: function() {
      //     if (this.model.langg_akhir) {
      //       return true;
      //     } else if ((this.model.eceran_akhir) || (this.model.konsi_akhir) || (this.model.titipan_akhir) ||(this.model.gratis_akhir))  {
      //       return true;
      //     } else return false;
      //   }
      // },
      // eceran_akhir: { required: function() {
      //     if (this.model.eceran_akhir) {
      //       return true;
      //     } else if ((this.model.langg_akhir) || (this.model.konsi_akhir) || (this.model.titipan_akhir) ||(this.model.gratis_akhir))  {
      //       return true;
      //     } else return false;
      //   }
      // },
      // konsi_akhir: {  required: function() {
      //     if (this.model.konsi_akhir) {
      //       return true;
      //     } else if ((this.model.eceran_akhir) || (this.model.langg_akhir) || (this.model.titipan_akhir) ||(this.model.gratis_akhir))  {
      //       return true;
      //     } else return false;
      //   }
      // },
      uraian: { required },
      tglrevisi: { required },
      revisigrpKey: { required },
    }
  },
  data() {
    return {
      isEdit: false,
      lkuKoranKirimanShow: false,
      showSaveConfirm: false,
      saveEnabled: true,
      tglkiriman: moment(this.$store.state.user.tglaktif,'YYYY-MM-DD').subtract(3,'month').format('YYYY-MM-DD'),
      tglaktif: this.$store.state.user.tglkoran,
      uanguser: this.$store.state.user.matauang,
      isLoading: false,
      maxTotalRevisi: 0,
      model: {
        kirimanKey: null,
        tglrevisi: moment().format("YYYY-MM-DD"),
        langg_akhir: 0,
        eceran_akhir: 0,
        konsi_akhir: 0,
        titipan_akhir: 0,
        gratis_akhir: 0,
        revisigrpKey: null
      },
      kiriman: {},
      tblData: {
        // tablename: "vwkorankota",
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tanggal",
        sortDesc: false
      },
      revisigrp: [],
      langganan: 0,
      konsi: 0
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function() {
    const [revisigrp] = await Promise.all([
      crud.list({ tablename: "koranrevisigroup" })
    ]);
    this.revisigrp = revisigrp.reduce((newArr = [], el, idx) => {
      newArr.push({ value: el.grpkey, text: el.grpname });
      return newArr;
    }, []);
    if (this.$route.params.revisiKey) {
      toastr.info("Harap tunggu, sedang memuat infromasi.");
      this.isEdit = true;
      try {
        const detail = await koran_kiriman_revisi.detail(this.$route.params);
        
          for (var key in detail[0]) {
              this.model[key] = detail[0][key];
          }
        this.model.tanggal = moment(this.model.tanggal).format("YYYY-MM-DD");
        this.model.tglrevisi = moment(this.model.tglrevisi).format("YYYY-MM-DD");
        this.model.CustInfo = `${this.model.CustCode +" | " +this.model.CustName}`;

        this.model.revtotal = this.model.revtotal - (this.model.total_rev);
        this.model.revtotpaid = this.model.revtotpaid - (this.model.eceran_rev);
        this.model.revlangg= this.model.revlangg-this.model.langg_rev;
        this.model.reveceran= this.model.reveceran-this.model.eceran_rev
        this.model.revkonsi= this.model.revkonsi - this.model.konsi_rev;
        this.model.revgratis= this.model.revgratis-this.model.gratis_rev;


        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
      }
    }
  },
  methods: {
    onSelectKoranKiriman(_selected) {
      this.lkuKoranKirimanShow = false;
      // if (_selected.kirimanKey) {
        // toastr.info("Harap tunggu, sedang memuat infromasi.");
        try {
          console.log('selected: ',_selected);
          this.model.CustInfo = `${_selected.CustCode +" | " +_selected.CustName}`;
          for (var key in _selected) {
              this.model[key] = _selected[key];
          }

          this.model.langg_akhir=_selected.langganan+_selected.revlangg;
          this.model.eceran_akhir=_selected.eceran+_selected.reveceran;
          this.model.konsi_akhir=_selected.konsi+_selected.revkonsi;
          this.model.gratis_akhir=_selected.gratis+_selected.revgratis;

          this.model.tanggal = moment(this.model.tanggal).format("YYYY-MM-DD");
          this.model.CustInfo = `${this.model.CustCode +" | " +this.model.CustName}`;
          this.$forceUpdate()
          toastr.clear;
        } catch (error) {
          this.lkuKoranKirimanShow = true;
          console.log("error : ", error);
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      // }
    },
    saveConfirm:  function(callback) {
      this.model.eceran_akhir= parseInt(this.model.langg_akhir)+ parseInt(this.model.konsi_akhir);
      // const revisiKaliIni=this.model.langg_akhir+this.model.eceran_akhir+this.model.konsi_akhir+this.model.titipan_akhir+this.model.gratis_akhir;
      // const RevisiPaidKaliIni=this.model.langg_akhir+this.model.eceran_akhir+this.model.konsi_akhir;
      if (this.model.eceran_akhir==0) {
        this.$bvModal.msgBoxConfirm('Totak Kiriman BERBAYAR direvisi jadi 0(Nol) eks. apakah anda yakin?', {
          title: 'Please Confirm',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })          
        .then( (value) => {
            if (value==true) {
            console.log('Lanjut SAVE');
              this.save()
            }

          })
          .catch(err => {
            // An error occurred
          })
      } else {
        this.save();
      }

    },
    save: async function(callback) {
              this.isLoading=true;
              if (this.invalidModel) {
                const invalidobj={};
                for (var key in this.$v.model) {
                  if (this.$v.model[key].$anyError) {
                    if (this.$v.model[key].$anyError==true) invalidobj[key] = this.$v.model[key];
                  }
                }        
                console.log('validation model: ', this.$v.model);
                console.log('validation field: ', invalidobj);
                toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
                this.isLoading=false;        
              } else if (moment(this.model.tglrevisi).format("YYYY-MM-DD")<this.tglaktif) {
                      toastr.error("Tanggal transaksi sudah CLOSED", "ERROR MESSAGE",10000);
                      this.isLoading=false;                
              } else {
                try {
                this.model.tglrevisi = moment(this.model.tglrevisi).format("YYYY-MM-DD");
                  const hasil= await koran_kiriman_revisi.save(this.model);
                  this.isLoading=false;
                  toastr.success(`Save successfully, Trx.Number ${hasil.no_revisi}`, this.$route.meta.label,10000);
                  this.isLoading=false;
                  this.close();
                } catch (error) {
                      this.isLoading=false;
                  console.log('error : ', error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }   
                  this.saveEnabled=true;            
                }
              }

    },
    close() {
      router.push({ name: "koran.revisikiriman" });
      //   if (this.$store.state.prevRoute.name) {
      //     router.push({ name: this.$store.state.prevRoute.name });
      //   } else {
      //     router.push({ name: "koran.customer" });
      //   }
    }
  }
};
</script>